/*
 * BOOTSTRAP
 */
$('[data-toggle="tooltip"]').tooltip();
$('[data-toggle="popover"]').popover();
